import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e64067e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_6 = { class: "expiry-container" }
const _hoisted_7 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning-content p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(" WARNING: By Changing any numeric value listed in this screen will cause serious effects on accounting records of inventory. ")
], -1))
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "barcode" }, "Barcode", -1))
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productType" }, "Product Type", -1))
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Description" }, "Description", -1))
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "brand" }, "Brand", -1))
const _hoisted_24 = {
  key: 0,
  class: "p-error"
}
const _hoisted_25 = { class: "p-col" }
const _hoisted_26 = { class: "p-field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "brandSector" }, "Brand Sector", -1))
const _hoisted_28 = {
  key: 0,
  class: "p-error"
}
const _hoisted_29 = { class: "p-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category" }, "Category", -1))
const _hoisted_31 = {
  key: 0,
  class: "p-error"
}
const _hoisted_32 = { class: "p-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sideEffects" }, "Side Effects", -1))
const _hoisted_34 = { class: "p-field" }
const _hoisted_35 = {
  key: 0,
  class: "p-error"
}
const _hoisted_36 = { class: "p-field" }
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = { class: "p-field" }
const _hoisted_39 = {
  key: 0,
  class: "p-error"
}
const _hoisted_40 = { class: "p-col" }
const _hoisted_41 = { class: "p-field" }
const _hoisted_42 = {
  key: 0,
  class: "p-error"
}
const _hoisted_43 = { class: "p-field" }
const _hoisted_44 = {
  key: 0,
  class: "p-error"
}
const _hoisted_45 = { class: "p-field" }
const _hoisted_46 = {
  key: 0,
  class: "p-error"
}
const _hoisted_47 = { class: "p-field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "packSelling" }, "Pack Selling", -1))
const _hoisted_49 = { class: "p-field" }
const _hoisted_50 = {
  key: 0,
  class: "p-error"
}
const _hoisted_51 = { class: "p-field" }
const _hoisted_52 = {
  key: 0,
  class: "p-error"
}
const _hoisted_53 = { class: "p-col" }
const _hoisted_54 = {
  key: 0,
  class: "p-field"
}
const _hoisted_55 = { for: "tax_1" }
const _hoisted_56 = {
  key: 1,
  class: "p-field"
}
const _hoisted_57 = { for: "tax_2" }
const _hoisted_58 = {
  key: 2,
  class: "p-field"
}
const _hoisted_59 = { for: "tax_3" }
const _hoisted_60 = { class: "p-field" }
const _hoisted_61 = {
  key: 0,
  class: "p-error"
}
const _hoisted_62 = { class: "p-field" }
const _hoisted_63 = {
  key: 0,
  class: "p-error"
}
const _hoisted_64 = { class: "confirmation-content" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Breadcrumb, {
              home: _ctx.home,
              model: _ctx.items,
              class: "p-menuitem-text"
            }, null, 8, ["home", "model"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Product Name, Generic Name, Batch No",
                style: {"width":"20rem"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search ",
                class: "p-button-success p-mr-1",
                onClick: _ctx.loadSearchData
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-times ",
                class: "p-button-info p-mr-1",
                onClick: _ctx.cleanSearchData
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DataTable, {
            first: _ctx.goToFirstLink,
            "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.lists,
            dataKey: "id",
            ref: "dt",
            lazy: true,
            paginator: _ctx.checkPagination,
            rows: _ctx.limit,
            totalRecords: _ctx.totalRecords,
            resizableColumns: true,
            columnResizeMode: "expand",
            responsiveLayout: "scroll",
            onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
            rowClass: _ctx.rowClass
          }, {
            empty: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Product Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_name), 1)
                ]),
                footer: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "reference",
                header: "Reference"
              }),
              _createVNode(_component_Column, { header: "Generic Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.generic_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Batch No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.batch_no), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit Qty" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(Number(slotProps.data.qty).toFixed(0)), 1)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(this.totalUnits), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Status" }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: "color-box",
                      style: _normalizeStyle({ backgroundColor: slotProps.data.status == 'Active' ? 'green':'red' })
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(slotProps.data.status), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: 'Unit Purchase ('+_ctx.currency+')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.purchase_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Unit Selling ('+_ctx.currency+')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.sale_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'MRP (Tax Inclusive) ('+_ctx.currency+')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.mrp), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Total Purchase ('+_ctx.currency+')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.fixDigits(_ctx.calculateItemWorth(slotProps.data.purchase_price,slotProps.data.qty,slotProps.data.pack_size))), 1)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.worthAmt).toFixed(2)), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, { header: "Disc %" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.discount_percentage) + " % ", 1)
                ]),
                _: 1
              }),
              (_ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    header: _ctx.taxNames[0].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_1) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    header: _ctx.taxNames[1].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_2) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    header: _ctx.taxNames[2].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_3) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, { header: "Expiry Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatExpiry(slotProps.data.expiry_date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Store Location" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_location), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Supplier" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.supplier_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Created Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords", "rowClass"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.productDialog,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.productDialog) = $event)),
      style: { width: '100vw' },
      maximizable: false,
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Save",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", {
                for: "productName",
                class: _normalizeClass({ 'p-error': _ctx.v$.productName.$invalid && _ctx.submitted })
              }, "Product Name", 2),
              _createVNode(_component_InputText, {
                id: "productName",
                modelValue: _ctx.v$.productName.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.productName.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.productName.$invalid && _ctx.submitted }),
                placeholder: "e.g Panadol"
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.productName.$invalid && _ctx.submitted) ||
                  _ctx.v$.productName.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.productName.required.$message.replace(
                    "Value",
                    "Product Name"
                  )), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", {
                for: "generic",
                class: _normalizeClass({ 'p-error': _ctx.v$.generic.$invalid && _ctx.submitted })
              }, "Generic Name", 2),
              _createVNode(_component_InputText, {
                id: "generic",
                modelValue: _ctx.v$.generic.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.generic.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.generic.$invalid && _ctx.submitted }),
                placeholder: "e.g Paracetamol"
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.generic.$invalid && _ctx.submitted) ||
                  _ctx.v$.generic.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.v$.generic.required.$message.replace("Value", "Generic Name")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_InputText, {
                id: "barcode",
                modelValue: _ctx.item.barcode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.barcode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Dropdown, {
                id: "productType",
                modelValue: _ctx.v$.productType.$model,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.productType.$model) = $event)),
                options: _ctx.productType,
                placeholder: "Product Type",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
                  (_ctx.v$.productType.$invalid && _ctx.submitted) ||
                  _ctx.v$.productType.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.productType.required.$message.replace(
                    "Value",
                    "Product Type"
                  )), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_InputText, {
                id: "Description",
                modelValue: _ctx.item.description,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.description) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_Dropdown, {
                id: "brand",
                modelValue: _ctx.v$.brand.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.brand.$model) = $event)),
                options: _ctx.brand,
                placeholder: "Brand",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
                  (_ctx.v$.brand.$invalid && _ctx.submitted) ||
                  _ctx.v$.brand.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(_ctx.v$.brand.required.$message.replace("Value", "Brand")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Dropdown, {
                id: "brandSector",
                modelValue: _ctx.v$.brandSector.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.brandSector.$model) = $event)),
                options: _ctx.brandSector,
                placeholder: "Brand Sector",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
                  (_ctx.v$.brandSector.$invalid && _ctx.submitted) ||
                  _ctx.v$.brandSector.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.v$.brandSector.required.$message.replace(
                    "Value",
                    "Brand Sector"
                  )), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_Dropdown, {
                id: "category",
                modelValue: _ctx.v$.category.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.category.$model) = $event)),
                options: _ctx.category,
                placeholder: "Category",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
                  (_ctx.v$.category.$invalid && _ctx.submitted) ||
                  _ctx.v$.category.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.v$.category.required.$message.replace("Value", "Category")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_InputText, {
                id: "sideEffects",
                modelValue: _ctx.item.sideEffects,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.sideEffects) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", {
                for: "packSize",
                class: _normalizeClass({ 'p-error': _ctx.v$.packSize.$invalid && _ctx.submitted })
              }, "Pack Size", 2),
              _createVNode(_component_InputNumber, {
                id: "packSize",
                modelValue: _ctx.v$.packSize.$model,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.packSize.$model) = $event)),
                useGrouping: false,
                class: _normalizeClass({ 'p-invalid': _ctx.v$.packSize.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.packSize.$invalid && _ctx.submitted) ||
                  _ctx.v$.packSize.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_ctx.v$.packSize.required.$message.replace("Value", "Pack Size")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", {
                for: "stripSize",
                class: _normalizeClass({ 'p-error': _ctx.v$.stripSize.$invalid && _ctx.submitted })
              }, "Strip Size", 2),
              _createVNode(_component_InputNumber, {
                id: "stripSize",
                modelValue: _ctx.v$.stripSize.$model,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.stripSize.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.stripSize.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.stripSize.$invalid && _ctx.submitted) ||
                  _ctx.v$.stripSize.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(_ctx.v$.stripSize.required.$message.replace("Value", "Strip Size")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", {
                for: "batchNo",
                class: _normalizeClass({ 'p-error': _ctx.v$.batchNo.$invalid && _ctx.submitted })
              }, "Batch No", 2),
              _createVNode(_component_InputText, {
                id: "batchNo",
                modelValue: _ctx.v$.batchNo.$model,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.batchNo.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.batchNo.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.batchNo.$invalid && _ctx.submitted) ||
                  _ctx.v$.batchNo.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_39, _toDisplayString(_ctx.v$.batchNo.required.$message.replace("Value", "Batch No")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", {
                for: "unitQty",
                class: _normalizeClass({ 'p-error': _ctx.v$.unitQty.$invalid && _ctx.submitted })
              }, "Unit Qty", 2),
              _createVNode(_component_InputNumber, {
                id: "batchNo",
                modelValue: _ctx.v$.unitQty.$model,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.unitQty.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.unitQty.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.unitQty.$invalid && _ctx.submitted) ||
                  _ctx.v$.unitQty.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_42, _toDisplayString(_ctx.v$.unitQty.required.$message.replace("Value", "Unit Qty")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", {
                for: "packPurchase",
                class: _normalizeClass({ 'p-error': _ctx.v$.packPurchase.$invalid && _ctx.submitted })
              }, "Pack Purchase", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "batchNo",
                modelValue: _ctx.v$.packPurchase.$model,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.packPurchase.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.packPurchase.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.packPurchase.$invalid && _ctx.submitted) ||
                  _ctx.v$.packPurchase.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.v$.packPurchase.required.$message.replace("Value", "Pack Purchase")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", {
                for: "mRP",
                class: _normalizeClass({ 'p-error': _ctx.v$.mRP.$invalid && _ctx.submitted })
              }, "MRP (Tax Inclusive)", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "mRP",
                modelValue: _ctx.v$.mRP.$model,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.mRP.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.mRP.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.mRP.$invalid && _ctx.submitted) ||
                  _ctx.v$.mRP.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.v$.mRP.required.$message.replace("Value", "Mrp")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "packSelling",
                modelValue: _ctx.item.packSelling,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.item.packSelling) = $event)),
                value: _ctx.fixDigits(_ctx.getPackSellingPrice()),
                disabled: true
              }, null, 8, ["modelValue", "value"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", {
                for: "disc",
                class: _normalizeClass({ 'p-error': _ctx.v$.disc.$invalid && _ctx.submitted })
              }, "Discount %", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "disc",
                modelValue: _ctx.v$.disc.$model,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.disc.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.disc.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.disc.$invalid && _ctx.submitted) ||
                  _ctx.v$.disc.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_50, _toDisplayString(_ctx.v$.disc.required.$message.replace("Value", "Disc %")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", {
                for: "storeLocation",
                class: _normalizeClass({ 'p-error': _ctx.v$.storeLocation.$invalid && _ctx.submitted })
              }, "Store Location", 2),
              _createVNode(_component_InputText, {
                id: "storeLocation",
                modelValue: _ctx.v$.storeLocation.$model,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.storeLocation.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.storeLocation.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.storeLocation.$invalid && _ctx.submitted) ||
                  _ctx.v$.storeLocation.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_52, _toDisplayString(_ctx.v$.storeLocation.required.$message.replace("Value", "Store Location")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            (_ctx.taxNames[0].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.taxNames[0].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_1",
                    modelValue: _ctx.item.tax_1,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.item.tax_1) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.taxNames[1].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_2",
                    modelValue: _ctx.item.tax_2,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.item.tax_2) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.taxNames[2].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_3",
                    modelValue: _ctx.item.tax_3,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.item.tax_3) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", {
                for: "expiryDate",
                class: _normalizeClass({ 'p-error': _ctx.v$.expiryDate.$invalid && _ctx.submitted })
              }, "Expiry Date", 2),
              _createVNode(_component_Calendar, {
                id: "expiryDate",
                modelValue: _ctx.v$.expiryDate.$model,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.v$.expiryDate.$model) = $event)),
                selectionMode: "single",
                dateFormat: "dd-mm-yy",
                class: "p-p-1"
              }, null, 8, ["modelValue"]),
              (
                  (_ctx.v$.expiryDate.$invalid && _ctx.submitted) ||
                  _ctx.v$.expiryDate.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_61, _toDisplayString(_ctx.v$.expiryDate.required.$message.replace("Value", "Expiry Date")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", {
                for: "minStock",
                class: _normalizeClass({ 'p-error': _ctx.v$.minStock.$invalid && _ctx.submitted })
              }, "Minimum Stock Requirement", 2),
              _createVNode(_component_InputText, {
                id: "minStock",
                modelValue: _ctx.v$.minStock.$model,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.v$.minStock.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.minStock.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
                  (_ctx.v$.minStock.$invalid && _ctx.submitted) ||
                  _ctx.v$.minStock.$pending.$response
                )
                ? (_openBlock(), _createElementBlock("small", _hoisted_63, _toDisplayString(_ctx.v$.minStock.required.$message.replace("Value", "Store Location")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteConfirmationDialog,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.deleteConfirmationDialog) = $event)),
      style: { width: '450px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-success",
          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.deleteConfirmationDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.handleClick
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("span", null, [
            _createTextVNode("Are you sure to " + _toDisplayString(_ctx.item.status === 'Active'? 'Reinstate':'Delete') + " ", 1),
            _createElementVNode("b", null, _toDisplayString(_ctx.state.productName), 1),
            _hoisted_66
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}